<script>
import {
  CdrGrid,
} from '@rei/cedar';
import OfferCard from '../offer-card/OfferCard.vue';

export default {
  name: 'OfferSet',
  components: {
    CdrGrid,
    OfferCard,
  },
  props: {
    cards: { type: Array, required: false, default: () => [] },
  },
  computed: {
    renderComponent() {
      return this.cards.length;
    },
    baseClass() {
      return this.cards.length % 2 === 0 ? 'offer-set--even' : 'offer-set--odd';
    },
    gridClass() {
      if ((this.cards.length - 1) % 3 === 0) {
        return 'offer-set--3n-minus-1';
      }

      if ((this.cards.length - 2) % 3 === 0) {
        return 'offer-set--3n-minus-2';
      }

      return 'offer-set--3n';
    },
  },
};
</script>
<template>
  <cdr-grid
    v-if="renderComponent"
    :class="[baseClass, gridClass]"
    class="offer-set"
  >
    <offer-card
      v-for="(card, i) in cards"
      :key="i"
      v-bind="card"
      class="offer-set__card-inner offer-set__card"
    />
  </cdr-grid>
</template>
<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

.offer-set {
  grid-template-columns: repeat(6, 1fr);;

  @include cdr-md-mq-up {
    gap: $cdr-space-one-and-a-half-x $cdr-space-one-and-a-half-x;
  }

  @include cdr-lg-mq-up {
    gap: $cdr-space-two-x $cdr-space-one-and-a-half-x;
  }

  &--3n-minus-1 {
    > :nth-child(1),
    > :nth-child(2),
    > :nth-last-child(1),
    > :nth-last-child(2) {
      @include cdr-sm-mq-up {
        grid-column: span 3;
      }
    }
  }

  &--3n-minus-2 {
    > :nth-child(1),
    > :nth-child(2) {
      @include cdr-sm-mq-up {
        grid-column: span 3;
      }
    }
  }

  &--odd {
    > :first-child {
      @include cdr-sm-mq-down {
        grid-column: span 6;
      }
    }
  }

  &__card {
    grid-column: span 3;

    @include cdr-sm-mq-up {
      grid-column: span 2;
    }
  }

  &__card-inner {
    padding: $cdr-space-half-x $cdr-space-half-x 0;
    @include cdr-md-mq-up {
      padding: $cdr-space-three-quarter-x $cdr-space-three-quarter-x 0;
    }
  }

  &__card-image-container {
    margin-bottom: $cdr-space-half-x;
    position: relative;

    @include cdr-md-mq-up {
      margin-bottom: $cdr-space-one-x;
    }
  }

  &__card-badge {
    position: absolute;
    left: 0;
    bottom: $cdr-space-one-x;
  }

  &__card-content {
    padding: $cdr-space-half-x;
  }

  &__card-title {
    &#{&} {
      @include cdr-text-heading-serif-500;
      margin: 0 0 $cdr-space-half-x;
      color: $cdr-color-text-sale;
      @include cdr-md-mq-up {
        @include cdr-text-heading-serif-600;
      }
    }
  }
  &__card-link {
    &#{&} {
      &:hover {
        color: $cdr-color-text-sale !important;
      }
    }
  }

  &__card-text {

    a {
      position: relative;
      z-index: 1;
    }

    &#{&} {
      @include cdr-text-body-300;
      margin: 0 0 $cdr-space-half-x;
    }
  }
}
</style>
